import React from 'react'
import PropTypes from 'prop-types'

const PrintableContent = ({ children }) => {
    return (
        <div>
            <style>
                {`
                /* Print-specific styles */
                @media print {
                    /* Hide viewing component, show print component */
                    .rubric-preview-view {
                        display: none !important;
                    }
                    .rubric-preview-print {
                        display: block !important;
                    }
                    /* Hide everything except the printable area */
                    body * {
                        visibility: hidden;
                    }
                    #printable-content, #printable-content * {
                        visibility: visible;
                    }
                    #printable-content {
                        position: absolute;
                        left: 0 !important;
                        top: 0 !important;
                        width: 100% !important;
                        max-width: 100% !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        overflow: visible !important;
                        box-sizing: border-box !important;
                    }
                    /* Ensure content fits within page boundaries */
                    #printable-content > div {
                        max-width: 100% !important;
                        box-sizing: border-box !important;
                    }
                    /* Ensure text is not cut off - but don't override specific rules */
                    #printable-content p,
                    #printable-content div:not([class*="react-diff-viewer"]):not(.ant-card),
                    #printable-content span:not([class*="react-diff-viewer"]),
                    #printable-content li {
                        overflow: visible !important;
                        text-overflow: clip !important;
                        white-space: normal !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                        page-break-inside: auto !important;
                        orphans: 3 !important;
                        widows: 3 !important;
                    }
                    /* Force fixed table layout to enforce strict column boundaries */
                    #printable-content .ant-table {
                        width: 100% !important;
                        table-layout: fixed !important;
                    }
                    /* Enforce strict column widths */
                    #printable-content .ant-table colgroup col:nth-child(1) {
                        width: 20% !important;
                    }
                    #printable-content .ant-table colgroup col:nth-child(2) {
                        width: 8% !important;
                    }
                    #printable-content .ant-table colgroup col:nth-child(3) {
                        width: 50% !important;
                    }
                    #printable-content .ant-table colgroup col:nth-child(4) {
                        width: 22% !important;
                    }
                    /* Aggressively reduce ALL spacing in printable content */
                    #printable-content .ant-typography,
                    #printable-content h1,
                    #printable-content h2,
                    #printable-content h3,
                    #printable-content h4,
                    #printable-content p {
                        margin: 4px 0 !important;
                    }
                    #printable-content .ant-flex {
                        margin: 0 !important;
                    }
                    /* Override all inline styles that add spacing */
                    #printable-content div[style*="margin"] {
                        margin-top: 4px !important;
                        margin-bottom: 4px !important;
                    }
                    /* Ensure table cells respect boundaries and wrap content */
                    #printable-content .ant-table td,
                    #printable-content .ant-table th {
                        overflow: visible !important;
                        white-space: normal !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                        max-width: 0 !important; /* Required for table-layout: fixed to work */
                        padding: 8px !important;
                        vertical-align: top !important;
                    }
                    /* Allow content to wrap but stay within cell boundaries */
                    #printable-content .ant-table-tbody > tr > td {
                        overflow: visible !important;
                        white-space: normal !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                        hyphens: auto !important;
                    }
                    /* Ensure inline diff renderer respects cell boundaries */
                    #printable-content .ant-table .inline-diff-renderer {
                        max-width: 100% !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                        box-sizing: border-box !important;
                    }
                    /* Ensure all content inside table cells wraps */
                    #printable-content .ant-table td *,
                    #printable-content .ant-table th * {
                        max-width: 100% !important;
                        word-wrap: break-word !important;
                        overflow-wrap: break-word !important;
                    }
                    /* Ensure no layout shifts from sidebar */
                    .site-layout-sider, 
                    .site-layout-header {
                        display: none !important;
                    }
                    /* Reset any content margin/padding */
                    #main-content {
                        margin: 0 !important;
                        padding: 0 !important;
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                    /* Hide all buttons */
                    button,
                    .ant-btn,
                    button[type="text"],
                    .ant-popover,
                    .ant-float-btn {
                        display: none !important;
                    }
                    /* Hide status tags (Pending, Finalized) */
                    .ant-tag {
                        display: none !important;
                    }
                    /* Hide Enhanced Description section - targets the Flex container with icon and text */
                    .ant-space-vertical > .ant-flex:first-child,
                    .ant-space-vertical .ant-flex:first-child {
                        display: none !important;
                    }
                    /* Remove card styling around Grading Reference */
                    .ant-card,
                    .ant-card-small,
                    .ant-card-body {
                        border: none !important;
                        box-shadow: none !important;
                        background: transparent !important;
                        padding: 0 !important;
                    }
                    /* Ensure diff viewer renders properly in print with colors */
                    .diff-viewer-container,
                    [class*="react-diff-viewer"] {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    /* Prevent page breaks inside diff viewer content */
                    [class*="react-diff-viewer"] * {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    /* Keep diff viewer columns together */
                    [class*="react-diff-viewer"] > div {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                        border: 1px solid var(--border-color) !important;
                    }
                    /* Force background colors to print - target specific diff viewer classes */
                    [class*="word-added"],
                    [class*="wordAdded"],
                    [class*="added"] {
                        background-color: var(--success-bg-color) !important;
                        color: var(--success-color) !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    [class*="word-removed"],
                    [class*="wordRemoved"],
                    [class*="removed"] {
                        background-color: var(--error-bg-color) !important;
                        color: var(--error-color) !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    /* Inline diff renderer styles for PDF */
                    .inline-diff-renderer ins {
                        background-color: var(--success-bg-color) !important;
                        color: var(--success-color) !important;
                        text-decoration: none !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    .inline-diff-renderer del {
                        background-color: var(--error-bg-color) !important;
                        color: var(--error-color) !important;
                        text-decoration: line-through !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    /* Prevent page breaks in table rows and cards */
                    .ant-table-tbody > tr,
                    .ant-card {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                    }
                    /* Force backgrounds to print for all printable content */
                    #printable-content * {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                }
                /* Screen styles for inline diff renderer */
                .inline-diff-renderer ins {
                    background-color: var(--success-bg-color);
                    color: var(--success-color);
                    text-decoration: none;
                }
                .inline-diff-renderer del {
                    background-color: var(--error-bg-color);
                    color: var(--error-color);
                    text-decoration: line-through;
                }
                /* Screen styles for table vertical alignment */
                #printable-content .ant-table td,
                #printable-content .ant-table th {
                    vertical-align: top;
                }
                `}
            </style>
            <div id='printable-content'>{children}</div>
        </div>
    )
}

PrintableContent.propTypes = {
    children: PropTypes.node.isRequired,
}

export default PrintableContent
